(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["m7-product-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('m7-product-share')) {
  customElements.define('m7-product-share', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const share = this.querySelector('[data-share]');
      const fallback = this.querySelector('[data-fallback]');
      const input = this.querySelector('[data-link]');
      const copy = this.querySelector('[data-copy]');
      const status = this.querySelector('[data-status]');
      const showFallback = () => {
        fallback.hidden = false;
        fallback.open = true;
        input.focus();
        input.select();
      };
      if (navigator.share || navigator.clipboard?.writeText) {
        share.hidden = false;
        fallback.hidden = true;
      }
      if (navigator.clipboard?.writeText) copy.hidden = false;
      const copyLink = async () => {
        try {
          await navigator.clipboard.writeText(this.dataset.url);
          status.textContent = this.dataset.copied;
        } catch {
          showFallback();
        }
      };
      copy.addEventListener('click', copyLink);
      share.addEventListener('click', async () => {
        status.textContent = '';
        if (navigator.share) {
          try {
            await navigator.share({ title: this.dataset.title, url: this.dataset.url });
          } catch (error) {
            if (error.name !== 'AbortError') showFallback();
          }
        } else {
          await copyLink();
        }
      });
      input.addEventListener('click', () => input.select());
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
